import { Grid, FormControl, Input, InputLabel } from '@material-ui/core';
import React from 'react';
import groupBy from 'lodash.groupby';

import CloseBtn from '../../../components/CloseBtn';
import SettingsGrid from './components/SettingsGrid';
import SettingsItem from './components/SettingsItem';
import Section from './components/Section';
import Logo from '../components/Logo';
import { API_ROOT } from '../../../../../../../../../../api/Routes';
import { AccountCircle } from '@material-ui/icons';

// TODO: render inputs dynamically

const renderSettingsItems = (preferences, onCriteriaToggle) => {
  if (!preferences) return;
  const groups = groupBy(preferences, p => p.parentId);
  let sections = [];
  for (let id in groups) {
    if (id === '1' || id === '2') {
      sections.push(...groups[id]);
    }
  }
  return (
    <React.Fragment>
      {sections.map((section, index) => (
        <Section key={index} name={section.name}>
          <SettingsGrid className="t-a-l">
            {[...groups[section.criteriaId]].map((item, i) => (
              <SettingsItem
                onChange={onCriteriaToggle(item.criteriaId)}
                checked={item.enabled}
                value={item.name}
                key={item.criteriaId}
                desc={item.name}
                name={item.name}
              />
            ))}
          </SettingsGrid>
        </Section>
      ))}
    </React.Fragment>
  );
};

const EditCompanyInfo = ({
  profile,
  onClose,
  onFieldUpdate,
  onCriteriaToggle,
  logoPreview,
  role,
  avatarWillBeDeleted,
  removeImage,
}) => (
  <div>
    <div className="u-mrg-bot-30">
      <CloseBtn onClick={onClose} />
      <h2 className="t-secondary-30 u-mrg-bot-30 u-mrg-top-60">
        {role[0] === 'ROLE_MANUFACTURER'
          ? 'Edit company info'
          : 'Edit product range'}
      </h2>
      {(function() {
        if (avatarWillBeDeleted)
          return (
            <div className="editProfileWrapper">
              <AccountCircle className="editProfileAvatar" />
              <input name="logo" type="file" onChange={onFieldUpdate()} />
            </div>
          );

        if (logoPreview) {
          return (
            <div className="editProfileWrapper">
              <Logo image={logoPreview} />
              {role[0] === 'ROLE_MANUFACTURER' ? (
                <input name="logo" type="file" onChange={onFieldUpdate()} />
              ) : null}
            </div>
          );
        }
        if (profile.logoImageId) {
          return (
            <div className="editProfileWrapper">
              <Logo
                image={`${API_ROOT}/asset/${profile.logoImageId}`}
                trigerRemoveImage={removeImage}
                showDeleteBtn={profile.logoImageId === null ? false : true}
              />
              {role[0] === 'ROLE_MANUFACTURER' ? (
                <input name="logo" type="file" onChange={onFieldUpdate()} />
              ) : null}
            </div>
          );
        }

        return (
          <div className="editProfileWrapper">
            <AccountCircle className="editProfileAvatar" />
            {role[0] === 'ROLE_MANUFACTURER' ? (
              <input name="logo" type="file" onChange={onFieldUpdate()} />
            ) : null}
          </div>
        );
      })()}

      <b className="c-s_gray t-primary-16 u-mrg-top-20 element-block">
        Add/change company logo
      </b>
    </div>
    <Grid container spacing={16}>
      <Grid item xs={12}>
        <FormControl fullWidth>
          <InputLabel
            htmlFor="companyName"
            classes={{
              root: 'label--c-gray',
            }}
          >
            Company name
          </InputLabel>
          <Input
            classes={{
              underline: 'underline--c-light',
            }}
            id="companyName"
            name="companyName"
            type="text"
            label="Company name"
            value={profile.companyName}
            onChange={onFieldUpdate()}
            disabled={role[0] === 'ROLE_MANUFACTURER' ? false : true}
          />
        </FormControl>
      </Grid>
      <Grid item xs={12}>
        <FormControl fullWidth>
          <InputLabel
            htmlFor="address"
            classes={{
              root: 'label--c-gray',
            }}
          >
            Company address
          </InputLabel>
          <Input
            classes={{
              underline: 'underline--c-light',
            }}
            id="address"
            name="address"
            type="text"
            label="Company address"
            value={profile.address}
            onChange={onFieldUpdate()}
          />
        </FormControl>
      </Grid>
    </Grid>
    <Grid container spacing={16}>
      <Grid item xs={6}>
        <FormControl fullWidth>
          <InputLabel
            htmlFor="phone"
            classes={{
              root: 'label--c-gray',
            }}
          >
            Phone
          </InputLabel>
          <Input
            classes={{
              underline: 'underline--c-light',
            }}
            id="phone"
            name="phone"
            type="text"
            label="Phone"
            value={profile.phone}
            onChange={onFieldUpdate()}
            disabled={role[0] === 'ROLE_MANUFACTURER' ? false : true}
          />
        </FormControl>
      </Grid>
      <Grid item xs={6}>
        <FormControl fullWidth>
          <InputLabel
            htmlFor="website"
            classes={{
              root: 'label--c-gray',
            }}
          >
            Website
          </InputLabel>
          <Input
            classes={{
              underline: 'underline--c-light',
            }}
            id="website"
            name="website"
            type="text"
            label="Website"
            value={profile.website}
            onChange={onFieldUpdate()}
            disabled={role[0] === 'ROLE_MANUFACTURER' ? false : true}
          />
        </FormControl>
      </Grid>
      <Grid item xs={12}>
        <FormControl fullWidth>
          <InputLabel
            htmlFor="registeredCompanyNumber"
            classes={{ root: 'label--c-gray' }}
          >
            Registered company number
          </InputLabel>
          <Input
            classes={{
              underline: 'underline--c-light',
            }}
            id="registeredCompanyNumber"
            name="registeredCompanyNumber"
            type="text"
            label="Registered company number"
            value={profile.registeredCompanyNumber}
            onChange={onFieldUpdate()}
            disabled={role[0] === 'ROLE_MANUFACTURER' ? false : true}
          />
        </FormControl>
      </Grid>
    </Grid>
    <h4 className="text--left u-mrg-bot-30 u-mrg-top-60">Product range</h4>
    <p className="text--left">
      Please select your company product range. Arup will use this criteria for
      sending your queries for specific type of lights. If you do not select
      some criteria you will not receive queries for this type of light.
    </p>
    {renderSettingsItems(profile.preferences, onCriteriaToggle)}
  </div>
);

export default EditCompanyInfo;
